import React, { FC, useRef } from 'react';
import { TouchCarousel } from './TouchCarousel';
import { MouseCarousel } from './MouseCarousel';
import { isTouchDevice } from '../../utils/domUtils';

type Props = {
  children: (resetScroll: Function) => React.ReactNode;
};

export const Carousel: FC<Props> = ({ children }) => {
  const touchDevied = useRef(isTouchDevice());

  return touchDevied.current ? (
    <TouchCarousel>{children}</TouchCarousel>
  ) : (
    <MouseCarousel>{children}</MouseCarousel>
  );
};
